module.exports = __webpack_public_path__ + "img/test-logo2.4a267c00.png";